import type { FC } from "react";

/**
 * Globale knappetekster.
 * BØR BRUKES I STEDENFOR HARDKODING AV TEKSTER I KNAPPER, FOR Å SIKRE KONSISTENS OG ENKLERE VEDLIKEHOLD.
 **/

// Navigering - Primary actions
export const GaVidere: FC = () => "Gå videre";
export const Tilbake: FC = () => "Tilbake";
export const Neste: FC = () => "Neste";
export const Forrige: FC = () => "Forrige";
export const Lukk: FC = () => "Lukk";
export const Avslutt: FC = () => "Avslutt";

// Form handlinger
export const Lagre: FC = () => "Lagre";
export const Avbryt: FC = () => "Avbryt";
export const Endre: FC = () => "Endre";
export const EndreValg: FC = () => "Endre valg";
export const Bekreft: FC = () => "Bekreft";
export const Slett: FC = () => "Slett";
export const LeggTil: FC = () => "Legg til";
export const ProvIgjen: FC = () => "Prøv igjen";

// "Tilbake" navigering
export const GaTilMinPensjon: FC = () => "Gå til Min pensjon";
export const GaTilMineOppgaver: FC = () => "Gå til Mine oppgaver";
export const GaTilOversikt: FC = () => "Gå til din oversikt";
export const GaTilAvtalesiden: FC = () => "Gå til avtalesiden";
export const GaTilbake: FC = () => "Gå tilbake";

// Utbetaling
export const StartUtbetaling: FC = () => "Start utbetaling";

// Authentication
export const LoggUt: FC = () => "Logg ut";

// Product actions
export const ByttProdukt: FC = () => "Bytt produkt";
export const SeDetaljer: FC = () => "Se detaljer";
export const LeggTilAvtale: FC = () => "Legg til avtale";
export const BekreftAvtalen: FC = () => "Bekreft avtalen";
export const LesMer: FC = () => "Les mer";
